/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { BadgeCheck } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j09-s04-autoridade-decidir';
export function DecidirDefesaPage() {
  const [e, setE] = useState<any>();
  const [id, setId] = useState('');
  const [fund, setFund] = useState('');
  const [busy, setBusy] = useState(false);
  async function call(p: string, b?: any) {
    setBusy(true);
    try {
      const x = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
      setE(x.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  useEffect(() => {
    if (e && !id) setId(e.pareceres[0]?.defesa_id ?? '');
  }, [e, id]);
  if (!e) return <p role="status">Carregando pareceres…</p>;
  const p = e.pareceres.find((x: any) => x.defesa_id === id),
    d = e.decisoes.find((x: any) => x.defesa_id === id),
    imp = e.impedimentos.find((x: any) => x.defesa_id === id);
  return (
    <main className="w-full min-w-0 space-y-4 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <BadgeCheck className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      <label>
        Parecer
        <select
          className="block w-full rounded-md border bg-background p-2"
          value={id}
          onChange={(x) => setId(x.target.value)}
        >
          {e.pareceres.map((x: any) => (
            <option key={x.id} value={x.defesa_id}>
              {x.id} · {x.recomendacao}
            </option>
          ))}
        </select>
      </label>
      {p && (
        <article className="rounded-md border p-3">
          <p>{p.fundamento}</p>
          <p>Analista: {p.analista}</p>
          <code className="break-all">{p.parecer_hash}</code>
        </article>
      )}
      {imp && <p role="alert">Aplicação suspensa por {imp.tipo}.</p>}
      {d ? (
        <article className="rounded-md border p-3">
          <h2 className="font-semibold">Decisão assinada</h2>
          <p>
            {d.resultado} · R$ {d.valor_final}
          </p>
          <p>{d.fundamento}</p>
          <p>
            {d.efeito_financeiro} · {d.efeito_cadastral}
          </p>
          <code className="break-all">{d.assinatura_hash}</code>
        </article>
      ) : (
        <>
          <label htmlFor="decisao">Fundamento da decisão</label>
          <textarea
            id="decisao"
            className="min-h-32 w-full rounded-md border bg-background p-3"
            value={fund}
            onChange={(x) => setFund(x.target.value)}
          />
          <Button
            disabled={busy || !p || !!imp || fund.length < 30}
            onClick={() =>
              void call('/verbs/decidir_defesa', {
                defesaId: id,
                resultado: 'MANTER',
                fundamento: fund,
                valorFinal: Number(p?.valor_recomendado ?? 0),
                recursoCabivel: false,
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            Assinar decisão
          </Button>
        </>
      )}
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
